// extracted by mini-css-extract-plugin
export var addressFields = "_kc-0";
export var animationContainer = "_kc-1";
export var footer = "_kc-2";
export var lineItems = "_kc-3";
export var modalContent = "_kc-4";
export var orderName = "_kc-5";
export var strong = "_kc-6";
export var warning = "_kc-7";